import _ from "lodash";
import React from "react";
import ReactPlayer from "react-player";
import styled from "styled-components";

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Streaming = ({ attribute }) => {
  const DEFAULT_URL = "rtmp://@178.63.101.40:1935/live/stream";
  const url = _.get(attribute, ["path"], DEFAULT_URL);

  return (
    <Container>
      <ReactPlayer
        url={`${url}`}
        controls
        playsinline
        playing
        width="100%"
        height="100%"
      />
    </Container>
  );
};
